import LocaleManager from "./locale_manager";

import * as locales from "./locales";

export default function(){
	return new LocaleManager(locales);
}